<template>
    <div>
        <div ref='paypal' style="width: 350px; height: 40px;"></div>
    </div>
</template>
<script>

import Configuration from '../../../../../../core/constants/configuration';
import baseUrl from '../../../../../../core/constants/uri';
export default {
    name: 'PayPalButton',
    props: {
        resumen: Object
    },
    mounted() {
        const script = document.createElement('script');
        const clientID = `${Configuration.value('paypalID')}`;
        script.src =
        `https://www.paypal.com/sdk/js?client-id=${clientID}&currency=EUR`;
        script.addEventListener('load', () => this.setLoaded())
        document.body.appendChild(script);
    },
    methods: {
        async setLoaded() {
            this.loaded = true;
            let token = ''
            let orderID = ''
            const authToken = localStorage.getItem('access_token') ? JSON.parse(localStorage.getItem('access_token')) : '';
            const resumen = { total: this.resumen.total, items: this.resumen.items.subtotal.items };
            window.paypal
                .Buttons({
                    async createOrder() {
                        token = await fetch(`${baseUrl}/paypal/authorization/token`, {
                            headers: {
                                Authorization: `Bearer ${authToken}`,
                            }
                        });
                        token = await token.json();
                        return fetch(`${baseUrl}/paypal/orders/create`, {
                            method: 'POST',
                            headers: {
                                'Content-Type': 'application/json',
                                'X-token': token.access_token,
                                Authorization: `Bearer ${authToken}`,
                            },
                            body: JSON.stringify({
                                'intent': 'CAPTURE',
                                'purchase_units': [
                                    {
                                        'items': resumen.items.map(item => {
                                            return {
                                                'name': `${item.title}`,
                                                'description': `${item.title}`,
                                                'quantity': 1,
                                                'unit_amount': {
                                                    'currency_code': 'EUR',
                                                    'value': `${item.monto}`
                                                }
                                            }
                                        }),
                                        'amount': {
                                            'currency_code': 'EUR',
                                            'value': `${resumen.total}`,
                                            'breakdown': {
                                                'item_total': {
                                                    'currency_code': 'EUR',
                                                    'value': `${resumen.total}`
                                                }
                                            }
                                        }
                                    }
                                ]
                            }),
                        }).then(res => res.json()).then(data => {
                            orderID = data.id;
                            return data.id
                        });
                    },
                    onApprove: async (data) => {
                        fetch(`${baseUrl}/paypal/orders/${data.orderID}/capture`, {
                            method: 'POST',
                            headers: {
                                'Content-Type': 'application/json',
                                'X-token': token.access_token,
                                Authorization: `Bearer ${authToken}`,
                            },
                            body: JSON.stringify({
                                'studentAccountIds': resumen.items.map((item) => item.id)
                            })
                        }).then(res => res.json()).then(orderData => {
                            fetch(`${baseUrl}/paypal/orders/${orderData.id}`, {
                                headers: {
                                    'X-token': token.access_token,
                                    Authorization: `Bearer ${authToken}`,
                                }
                            }).then(res => res.json()).then(serverData => {
                                if (serverData.status === 'COMPLETED' && serverData.id === orderID) {
                                    this.$emit('changeStep', 'approved');
                                    this.$store.commit('commons/SET_SIGNED_USERDATA', true);
                                }
                                else this.paidFor = false;
                            });
                        });
                    },
                    onError() {
                    },
                    style: {
                        layout: 'horizontal',
                        tagline: 'false',
                        color: 'silver'
                    }
                })
                .render(this.$refs.paypal);
        }
    }
};
</script>
